import { Filter, Header } from '../../../components/SubHeaderFilter/types';
import {
  FINANCIAL_ENTRY_STATUS_OPTIONS,
  FINANCIAL_VIEW_BY,
  FinancialViewByValue,
} from './constants';
import { CustomFilterOperatorValue } from './constants';

const ACCOUNT_FILTER_FIELD: Header = {
  key: 'account',
  label: 'Conta a',
  type: 'string',
  selectOptions: [
    { value: '0', label: 'A receber' },
    { value: '1', label: 'A pagar' },
  ],
};

const STATUS_FILTER_FIELD: Header = {
  key: 'status',
  label: 'Status',
  type: 'string',
  selectOptions: FINANCIAL_ENTRY_STATUS_OPTIONS.map((option) => ({
    value: String(option.value),
    label: option.label,
  })),
};

const ENTRY_FILTER_HEADERS: Header[] = [
  { key: 'number', label: 'Número', type: 'number' },
  { key: 'date', label: 'Registro', type: 'date' },
  { key: 'totalValue', label: 'Valor', type: 'currency' },
  { key: 'company', label: 'Empresa', type: 'string' },
  { key: 'businessUnit', label: 'BU', type: 'string' },
  STATUS_FILTER_FIELD,
  ACCOUNT_FILTER_FIELD,
  { key: 'dueDate', label: 'Vencimento', type: 'date' },
];

const PAYMENT_FILTER_HEADERS: Header[] = [
  { key: 'entryNumber', label: 'Número do Lançamento', type: 'number' },
  { key: 'number', label: 'Número', type: 'number' },
  { key: 'date', label: 'Registro', type: 'date' },
  { key: 'value', label: 'Valor', type: 'currency' },
  { key: 'company', label: 'Empresa', type: 'string' },
  { key: 'businessUnit', label: 'BU', type: 'string' },
  STATUS_FILTER_FIELD,
  ACCOUNT_FILTER_FIELD,
  { key: 'dueDate', label: 'Vencimento', type: 'date' },
];

const ITEM_FILTER_HEADERS: Header[] = [...ENTRY_FILTER_HEADERS];

export const getFinancialFilterHeaders = (
  viewBy?: FinancialViewByValue,
): Header[] => {
  switch (viewBy) {
    case FINANCIAL_VIEW_BY.PAYMENT:
      return PAYMENT_FILTER_HEADERS;
    case FINANCIAL_VIEW_BY.ITEM:
      return ITEM_FILTER_HEADERS;
    default:
      return ENTRY_FILTER_HEADERS;
  }
};

export const financialEntryFilterHeaders = ENTRY_FILTER_HEADERS;

const FILTER_TYPE_TO_OPERATOR: Record<string, CustomFilterOperatorValue> = {
  Contém: 'contains',
  'Não contém': 'notContains',
  'Igual a': 'equals',
  'É diferente de': 'notEquals',
  'Diferente de': 'notEquals',
  'Começa com': 'startsWith',
  'Termina com': 'endsWith',
  'Maior que': 'gt',
  'Menor que': 'lt',
  'É maior/igual que': 'gte',
  'É menor/igual que': 'lte',
  'Antes de': 'lt',
  'Depois de': 'gt',
};

type CustomFilterPayload = {
  field: string;
  operator: CustomFilterOperatorValue;
  value?: string;
};

const toRuleValue = (filter: Filter): string | undefined => {
  if (filter.value === null || filter.value === undefined || filter.value === '') {
    return undefined;
  }

  if (typeof filter.value === 'object' && 'start' in filter.value && 'end' in filter.value) {
    return undefined;
  }

  return String(filter.value);
};

export const filterToCustomRules = (filter: Filter): CustomFilterPayload[] => {
  const operator = FILTER_TYPE_TO_OPERATOR[filter.filterType];
  if (!operator) return [];

  if (
    filter.filterType === 'Intervalo' &&
    filter.value &&
    typeof filter.value === 'object' &&
    'start' in filter.value &&
    'end' in filter.value
  ) {
    const { start, end } = filter.value as { start: string; end: string };
    if (!start || !end) return [];

    return [
      { field: filter.key, operator: 'gte', value: start },
      { field: filter.key, operator: 'lte', value: end },
    ];
  }

  const value = toRuleValue(filter);
  if (value === undefined && operator !== 'empty' && operator !== 'notEmpty') {
    return [];
  }

  return [{ field: filter.key, operator, value }];
};

export const filtersToCustomRules = (filters: Filter[]): CustomFilterPayload[] =>
  filters.flatMap(filterToCustomRules);
